import React from "react";
import { Navigate } from "react-router-dom";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWallPte from "../components/Frontend/FameWallPte";
import Testimonial from "../components/Frontend/Testimonial";
import WhyLove from "../components/Frontend/WhyLove";
import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";
import NaatiTut from "../components/Frontend/NaatiTut";
import SimpleReactValidator from "simple-react-validator";
import { store } from "store/index";
import { setAlert } from "action/index.js";
import API from "api.js";
import { Helmet } from "react-helmet";
import ReactGA from "react-ga";
import ReactPixel from "react-facebook-pixel";
import Slider from "react-slick";
import { Link } from "react-router-dom";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { Slide } from "react-toastify";
import SuccessfulStudent from "../components/Frontend/Sliders/SuccessfulStudent";
import TrainingOnline from "../components/Frontend/Sliders/TrainingOnline";

class Pte extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      homePage: false,
      list: [],
      sliderStyles: { marginLeft: "0px", width: "100%" },
    };
    this.sliderRef = React.createRef();

    this.state = {
      isActive: false,
      name: "",
      email: "",
      phone: "",
      readMoreFlag: false,
      course: "NAATI CCL Online",
      query: "",
      lang: "Hindi",
      flag: false,
      loginLock: false,
    };
    this.validator = new SimpleReactValidator();
  }
  handleClick = () => {
    this.setState((prevState) => ({
      isActive: !prevState.isActive,
    }));
  };

  componentDidMount() {
    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);
    ReactPixel.init("2474090032742391");
    ReactPixel.init("197333187452630");
    ReactPixel.pageView();
  }
  submitForm = (e) => {
    e.preventDefault();
    this.hitApi();
  };

  hitApi = async () => {
    if (this.state.loginLock) {
      return;
    }
    if (!this.validator.allValid()) {
      this.validator.showMessages();
      this.forceUpdate();
      return;
    }
    this.setState({ loginLock: true });

    var bodyFormData = new FormData();
    bodyFormData.set("email", this.state.email);
    bodyFormData.set("name", this.state.name);
    bodyFormData.set("phone", this.state.phone);
    bodyFormData.set(
      "message",
      "<b>Language:</b> " +
        this.state.lang +
        "<br/><b>Course:</b> " +
        this.state.course +
        "<br/><b>Query:</b> " +
        this.state.query
    );
    bodyFormData.set(
      "data",
      "email: " +
        this.state.email +
        ",name: " +
        this.state.name +
        ",phone: " +
        this.state.phone +
        ",course: " +
        this.state.course +
        ",query: " +
        this.state.query
    );
    bodyFormData.set("page", "NAATI Online coaching");
    let res = null;
    try {
      res = await API({
        method: "POST",
        url: "sendOnlinePte",
        data: bodyFormData,
      });
    } catch (error) {}
    console.log(res);
    if (res?.status === 200) {
      store.dispatch(
        setAlert({ flag: true, type: 1, message: res.data.message })
      );
      this.setState({
        name: "",
        email: "",
        phone: "",
        course: "PTE On-Campus",
        query: "",
        loginLock: false,
        flag: true,
      });
    } else {
      this.setState({ loginLock: false });
    }
  };

  changeInput = (e) => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
  };
  changeReadMore = () => {
    this.setState({ readMoreFlag: !this.state.readMoreFlag });
  };

  render() {
    if (this.state.flag) {
      return <Navigate to="/thank-you" replace />;
    }

    const customslider = {
      dots: false,
      arrows: false,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 4000,
    };
    const pteSlider = {
      dots: true,
      arrows: true,
      speed: 500,
      slidesToShow: 6,
      slidesToScroll: 1,
      autoplay: false,
      autoplaySpeed: 2000,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 5,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 4,
          },
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 2,
          },
        },
      ],
    };
    // const trainingSlider = {
    //   dots: true,
    //   arrows: true,
    //   speed: 500,
    //   slidesToShow: 3.5,
    //   slidesToScroll: 1,
    //   autoplay: false,
    //   autoplaySpeed: 2000,
    //   responsive: [
    //     {
    //       breakpoint: 992,
    //       settings: {
    //         slidesToShow: 2.5,
    //       },
    //     },
    //     {
    //       breakpoint: 768,
    //       settings: {
    //         slidesToShow: 2.5,
    //       },
    //     },
    //     {
    //       breakpoint: 576,
    //       settings: {
    //         slidesToShow: 1.5,
    //       },
    //     },
    //   ],
    // };

    const CardsSlider = {
      dots: true,
      arrows: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      adaptiveHeight: true,
      autoplaySpeed: 2000,
    };

    return (
      <React.Fragment>
        <Helmet>
          <title>
            NAATI CCL Online Coaching Classes Australia | Language Academy
          </title>
          <meta
            name="twitter:title"
            content="NAATI CCL Online Coaching Centre - Language Academy"
          />
          <meta
            property="og:title"
            content="NAATI CCL Online Coaching Centre - Language Academy"
          />
          <meta
            name="description"
            content="Prepare for the NAATI CCL exam with Language Academy's online coaching classes in Australia. Access expert guidance and practice materials to succeed."
          />

          <meta
            name="twitter:description"
            content="Language Academy, one of the best NAATI CCL online training centre in Australia. We help you to prepare for the NAATI test course in Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese and help you perform better in the exam. To join the best NAATI CCL preparation online classes, get in touch with us now!"
          />
          <meta
            property="og:description"
            content="Language Academy, one of the best NAATI CCL online training centre in Australia. We help you to prepare for the NAATI test course in Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese and help you perform better in the exam. To join the best NAATI CCL preparation online classes, get in touch with us now!"
          />
        </Helmet>
        <Header />
        <div className="banner-section noc-banner">
          <div className="container">
            <div className="row">
              <div className="banner-content">
                <h1 className="primary-heading dark-blue-color">                  
                  <span className="fw-700">MASTER NAATI CCL FROM ANYWHERE</span><br />
                  PROFESSIONAL NAATI CCL ONLINE <br /> COACHING FOR <span className="wpl-badge pte-naati-badge text-white">PR SUCCESS</span>
                </h1>
                <p className="sub-title">
                  Expert-led NAATI CCL training with flexible scheduling, personalized feedback, <br className="d-none d-md-block" /> and everything you need to pass on your first attempt.
                </p>
                <div className="iframe-video-outer position-relative">
                  {/* <div className="iframe-video-wrapper">
                    <iframe
                      className="iframe-video"
                      src="https://www.youtube.com/embed/6tJN984IoQ4?si=rlOsVJWragJc0zie"
                      title="YouTube video player"
                      frameBorder="0"
                      allowFullScreen
                    ></iframe>
                  </div> */}
                  <div className="banner-img-wrapper">
                    <img
                      className="banner-img"
                      src="/images/web-new-images/banners/ncoc-banner.png"
                      alt="LA"
                    />
                  </div>
                  <img
                    className="emoji1 position-absolute"
                    src="/images/web-new-images/emojis/emoji-4.png"
                    alt="LA"
                  />
                  <img
                    className="emoji2 position-absolute"
                    src="/images/web-new-images/emojis/emoji-2.png"
                    alt="LA"
                  />
                  <img
                    className="emoji3 position-absolute"
                    src="/images/web-new-images/emojis/emoji-3.png"
                    alt="LA"
                  />
                  <img
                    className="emoji4 position-absolute"
                    src="/images/web-new-images/emojis/emoji-1.png"
                    alt="LA"
                  />
                </div>
                <div className="light-blue-box">
                  Achieve your goal of passing the NAATI CCL exam with personalized NAATI CCL coaching, designed for aspiring immigrants, students, and language learners.
                  <br />
                  <br />
                  Gain confidence in your translation and interpretation skills, earn extra points for Australian PR, and unlock your potential with our comprehensive NAATI CCL online course training program.
                </div>
                <button
                  className="primary-btn mt-2 border-0"
                  type="button"
                  data-bs-toggle="modal"
                  data-bs-target="#staticBackdrop1"
                >
                  ENROLL IN OUR PROGRAM TODAY{" "}
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </button>
              </div>
            </div>
          </div>
        </div>
        <div className="noc-ccl-exam">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge pte-naati-badge text-white">
                    WHAT IS THE NAATI CCL EXAM?
                  </span>
                  <br className="d-block" />
                  YOUR GATEWAY TO AUSTRALIAN <br className="d-block" />{" "}
                  PERMANENT RESIDENCY
                </h2>
              </div>
              <div className="col-md-6">
                <div className="ccl-exam-img">
                  <img
                    src="/images/web-new-images/nati-ccl-img.png"
                    alt="Register Now"
                  />
                </div>
                <p>
                  The NAATI Credentialled Community Language (CCL) exam is a critical test that evaluates your ability to interpret and translate between English and your chosen language. Passing this test can earn you an extra <strong>five points</strong> toward your Australian Permanent Residency (PR).
                  <br />
                  <br />
                  The exam consists of two dialogue recordings, each presenting a conversation between an English speaker and a speaker in your specific language. Your task is to interpret and translate accurately while demonstrating confidence and cultural understanding.
                </p>
                <div className="text-center text-md-start mb-4 mb-md-0">
                  {/* <Link className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      START YOUR NAATI CCL PREP JOURNEY NOW{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </Link> */}
                  <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register"  className="primary-btn" to="/auth/register">
                    <span className="btn-inner">
                      START YOUR NAATI CCL PREP JOURNEY NOW{" "}
                      <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </span>
                  </a>
                </div>
              </div>
              <div className="col-md-6">
                <h2 className="content-title">NAATI CCL Test Pattern</h2>
                <p>
                  The NAATI CCL test assesses your language skills at a community level through recorded conversation dialogues:
                </p>
                <ul className="circle-list">
                  <li>
                    <strong>Two recordings</strong> with dialogues of 300 words each
                  </li>
                  <li>
                    <strong>30 minutes</strong> total time to complete both recordings
                  </li>
                  <li>
                    <strong>Segments of 35 words</strong> each carrying 45 marks
                  </li>
                  <li>
                    <strong>Minimum score of 29</strong> required in each dialogue to pass successfully
                  </li>
                  <li>
                    <strong>Available in 12 languages:</strong> Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Kannada and Marathi
                  </li>
                </ul>
                <div className="light-blue-box">
                  By combining the right resources, expert coaching, and regular practice, you'll not only ace the test but also gain essential skills in bilingual communication. Don't let fear or inexperience hold you back.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="noc-training-online">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <h2 className="primary-heading text-center fw-700">
                  <span className="wpl-badge gold-badge text-white">
                    WHY TAKE NAATI CCL
                  </span>
                  <br className="d-block" />
                  TRAINING ONLINE?
                </h2>
                <p className="sub-title text-center">
                  Attending an on-campus program can be difficult for many people <br className="d-none d-md-block" /> with busy schedules, work commitments, or geographical constraints. <br className="d-none d-md-block" /> Our NAATI CCL online coaching offers the perfect solution:
                </p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <TrainingOnline />
        </div>

        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <p className="light-blue-box">
                NAATI CCL online classes let you hone your translation and interpretation skills with the ease of accessing the course from anywhere you want. 
              </p>
              <p>
                Say goodbye to unreliable self-study plans and outdated materials, our system is designed to get you results.
              </p>
            </div>
            <div className="col-md-6">
              <p className="light-blue-box">
                You can easily balance your underlying commitments and NAATI CCL training by attending our online coaching sessions.
              </p>
              <div className="text-center text-md-end">
                {/* <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    ENROLL FOR NAATI CCL COACHING TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link> */}
                <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    ENROLL FOR NAATI CCL COACHING TODAY
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}

        <div className="challenge-section">
          <div className="container">
            <div className="row first-row">
              <div className="col-md-6">
                <h2 className="primary-heading fw-700 text-white">
                  OVERCOME
                  <br />
                  YOUR CHALLENGES <br /> WITH OUR <span className="wpl-badge gold-badge text-white">
                    TAILORED
                  </span>
                  <br />
                  <span className="wpl-badge gold-badge text-white">
                    ONLINE SOLUTIONS
                  </span>
                </h2>
              </div>
              <div className="col-md-6">
                <p className="sub-title text-white text-center text-md-start">
                  Struggling to find quality resources or balance your
                  preparation with a busy schedule? You're not alone! We
                  understand the key concerns of NAATI CCL aspirants, including
                </p>
                <ul className="text-white">
                  <li>Difficulty attending on-campus courses</li>
                  <li>Lack of access to reliable preparation materials</li>
                  <li>Insufficient practice opportunities</li>
                  <li>Fear of failing the NAATI CCL exam</li>
                </ul>
                <p className="sub-title text-white">
                  Our online coaching program is designed to eliminate these
                  barriers, giving you the tools, support, and confidence you
                  need to succeed.
                </p>
              </div>
            </div>
            <div className="row second-row">
              <div className="col-md-12">
                <h2 className="primary-heading text-white text-center">
                  OUR COMPREHENSIVE NAATI CCL <br className="d-none d-md-block" /> ONLINE COURSE PREPARATION INCLUDES
                </h2>
                <p className="sub-title text-white text-center">
                  At Language Academy, our NAATI CCL training preparation <br className="d-none d-md-block" /> course curriculum includes modules strategized after <br className="d-none d-md-block" /> carefully assessing your skills.
                </p>
              </div>
            </div>
            <h2 className="comprehensive-title text-white">
              We understand how important this course is for you to claim five additional points towards your Australian permanent residency.
            </h2>

            <div className="third-row blue-card-row d-none d-md-grid">
              <div className="feature-card card1">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 11.2119H21M1 11.2119C1 16.7348 5.47715 21.2119 11 21.2119M1 11.2119C1 5.68907 5.47715 1.21191 11 1.21191M21 11.2119C21 16.7348 16.5228 21.2119 11 21.2119M21 11.2119C21 5.68907 16.5228 1.21191 11 1.21191M11 1.21191C13.5013 3.95027 14.9228 7.50395 15 11.2119C14.9228 14.9199 13.5013 18.4736 11 21.2119M11 1.21191C8.49872 3.95027 7.07725 7.50395 7 11.2119C7.07725 14.9199 8.49872 18.4736 11 21.2119"
                        stroke="#0286FF"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                  ONLINE PRACTICE <br /> PLATFORM 
                </h3>
                <p>Learn from anywhere with our easy-to-use NAATI online course digital tools.</p>
              </div>
              <div className="feature-card card2">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 6.21191V12.2119L16 14.2119M22 12.2119C22 17.7348 17.5228 22.2119 12 22.2119C6.47715 22.2119 2 17.7348 2 12.2119C2 6.68907 6.47715 2.21191 12 2.21191C17.5228 2.21191 22 6.68907 22 12.2119Z"
                        stroke="#94C23C"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                  REAL-TIME <br />  MOCK TESTS
                </h3>
                <p>
                  Simulate the actual exam environment through our NAATI CCL coaching platform to boost your readiness.
                </p>
              </div>
              <div className="feature-card card3">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 17.7119H12.01M8.2 22.2119H15.8C16.9201 22.2119 17.4802 22.2119 17.908 21.9939C18.2843 21.8022 18.5903 21.4962 18.782 21.1199C19 20.6921 19 20.132 19 19.0119V5.41191C19 4.29181 19 3.73176 18.782 3.30393C18.5903 2.92761 18.2843 2.62165 17.908 2.4299C17.4802 2.21191 16.9201 2.21191 15.8 2.21191H8.2C7.0799 2.21191 6.51984 2.21191 6.09202 2.4299C5.71569 2.62165 5.40973 2.92761 5.21799 3.30393C5 3.73176 5 4.29181 5 5.41191V19.0119C5 20.132 5 20.6921 5.21799 21.1199C5.40973 21.4962 5.71569 21.8022 6.09202 21.9939C6.51984 22.2119 7.07989 22.2119 8.2 22.2119ZM12.5 17.7119C12.5 17.9881 12.2761 18.2119 12 18.2119C11.7239 18.2119 11.5 17.9881 11.5 17.7119C11.5 17.4358 11.7239 17.2119 12 17.2119C12.2761 17.2119 12.5 17.4358 12.5 17.7119Z"
                        stroke="#7F56D9"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                   NAATI CCL <br /> MOBILE APP
                </h3>
                <p>Practice vocabulary and dialogues on the go, anytime with our NAATI CCL Online Classes mobile application.</p>
              </div>
              <div className="feature-card card4">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 16.2119V21.2119M12 16.2119L18 21.2119M12 16.2119L6 21.2119M8 7.21191V12.2119M12 9.21191V12.2119M16 11.2119V12.2119M22 3.21191H2M3 3.21191H21V11.4119C21 13.0921 21 13.9321 20.673 14.5739C20.3854 15.1384 19.9265 15.5973 19.362 15.8849C18.7202 16.2119 17.8802 16.2119 16.2 16.2119H7.8C6.11984 16.2119 5.27976 16.2119 4.63803 15.8849C4.07354 15.5973 3.6146 15.1384 3.32698 14.5739C3 13.9321 3 13.0921 3 11.4119V3.21191Z"
                        stroke="#FFB02C"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                  NAATI CCL <br /> ONLINE COACHING
                </h3>
                <p>Get one-on-one guidance from NAATI-certified trainers.</p>
              </div>
            </div>

            <div className="slider-dot-arrow d-block d-md-none">
              <Slider {...CardsSlider} className="third-row blue-card-row">
                <div className="feature-card card1">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 11.2119H21M1 11.2119C1 16.7348 5.47715 21.2119 11 21.2119M1 11.2119C1 5.68907 5.47715 1.21191 11 1.21191M21 11.2119C21 16.7348 16.5228 21.2119 11 21.2119M21 11.2119C21 5.68907 16.5228 1.21191 11 1.21191M11 1.21191C13.5013 3.95027 14.9228 7.50395 15 11.2119C14.9228 14.9199 13.5013 18.4736 11 21.2119M11 1.21191C8.49872 3.95027 7.07725 7.50395 7 11.2119C7.07725 14.9199 8.49872 18.4736 11 21.2119"
                        stroke="#0286FF"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                  ONLINE PRACTICE <br /> PLATFORM 
                </h3>
                <p>Learn from anywhere with our easy-to-use NAATI online course digital tools.</p>
              </div>
              <div className="feature-card card2">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 6.21191V12.2119L16 14.2119M22 12.2119C22 17.7348 17.5228 22.2119 12 22.2119C6.47715 22.2119 2 17.7348 2 12.2119C2 6.68907 6.47715 2.21191 12 2.21191C17.5228 2.21191 22 6.68907 22 12.2119Z"
                        stroke="#94C23C"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                  REAL-TIME <br />  MOCK TESTS
                </h3>
                <p>
                  Simulate the actual exam environment through our NAATI CCL coaching platform to boost your readiness.
                </p>
              </div>
              <div className="feature-card card3">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 17.7119H12.01M8.2 22.2119H15.8C16.9201 22.2119 17.4802 22.2119 17.908 21.9939C18.2843 21.8022 18.5903 21.4962 18.782 21.1199C19 20.6921 19 20.132 19 19.0119V5.41191C19 4.29181 19 3.73176 18.782 3.30393C18.5903 2.92761 18.2843 2.62165 17.908 2.4299C17.4802 2.21191 16.9201 2.21191 15.8 2.21191H8.2C7.0799 2.21191 6.51984 2.21191 6.09202 2.4299C5.71569 2.62165 5.40973 2.92761 5.21799 3.30393C5 3.73176 5 4.29181 5 5.41191V19.0119C5 20.132 5 20.6921 5.21799 21.1199C5.40973 21.4962 5.71569 21.8022 6.09202 21.9939C6.51984 22.2119 7.07989 22.2119 8.2 22.2119ZM12.5 17.7119C12.5 17.9881 12.2761 18.2119 12 18.2119C11.7239 18.2119 11.5 17.9881 11.5 17.7119C11.5 17.4358 11.7239 17.2119 12 17.2119C12.2761 17.2119 12.5 17.4358 12.5 17.7119Z"
                        stroke="#7F56D9"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                   NAATI CCL <br /> MOBILE APP
                </h3>
                <p>Practice vocabulary and dialogues on the go, anytime with our NAATI CCL Online Classes mobile application.</p>
              </div>
              <div className="feature-card card4">
                <div className="rounded-circle">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12 16.2119V21.2119M12 16.2119L18 21.2119M12 16.2119L6 21.2119M8 7.21191V12.2119M12 9.21191V12.2119M16 11.2119V12.2119M22 3.21191H2M3 3.21191H21V11.4119C21 13.0921 21 13.9321 20.673 14.5739C20.3854 15.1384 19.9265 15.5973 19.362 15.8849C18.7202 16.2119 17.8802 16.2119 16.2 16.2119H7.8C6.11984 16.2119 5.27976 16.2119 4.63803 15.8849C4.07354 15.5973 3.6146 15.1384 3.32698 14.5739C3 13.9321 3 13.0921 3 11.4119V3.21191Z"
                        stroke="#FFB02C"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                </div>
                <h3>
                  NAATI CCL <br /> ONLINE COACHING
                </h3>
                <p>Get one-on-one guidance from NAATI-certified trainers.</p>
              </div>
              </Slider>
            </div>

            <div className="row forth-row">
              <div className="col-md-6">
                <div className="light-blue-box blue-box">
                  With us, your preparation journey is flexible, efficient, and results-driven.
                </div>
              </div>
              <div className="col-md-6 text-center text-md-end">
                {/* <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    GET STARTED WITH OUR ONLINE PROGRAM{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link> */}
                <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    GET STARTED WITH OUR ONLINE PROGRAM{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="why-choosing-section poc-why-choosing">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center">
                <span className="wpl-badge text-white">Language Academy</span>
                <br className="d-block" />
                NAATI CCL MOBILE APPLICATION FOR
                <br className="d-block" />
                COMPREHENSIVE PREPARATION
              </h2>
              <p className="sub-heading text-center">
                Our specialized mobile app provides complete
                <br className="d-none d-md-block" />
                preparation tools designed for NAATI CCL success
              </p>
              <div className="feature-cards four-cards">
                <div className="feature-card card-1">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="22"
                        height="21"
                        viewBox="0 0 22 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 19.5488L10.8999 19.3987C10.2053 18.3568 9.85798 17.8358 9.3991 17.4586C8.99286 17.1248 8.52476 16.8742 8.02161 16.7214C7.45325 16.5488 6.82711 16.5488 5.57482 16.5488H4.2C3.07989 16.5488 2.51984 16.5488 2.09202 16.3308C1.71569 16.1391 1.40973 15.8331 1.21799 15.4568C1 15.029 1 14.4689 1 13.3488V4.74883C1 3.62872 1 3.06867 1.21799 2.64085C1.40973 2.26452 1.71569 1.95856 2.09202 1.76682C2.51984 1.54883 3.07989 1.54883 4.2 1.54883H4.6C6.84021 1.54883 7.96031 1.54883 8.81596 1.9848C9.56861 2.3683 10.1805 2.98022 10.564 3.73287C11 4.58851 11 5.70862 11 7.94883M11 19.5488V7.94883M11 19.5488L11.1001 19.3987C11.7947 18.3568 12.142 17.8358 12.6009 17.4586C13.0071 17.1248 13.4752 16.8742 13.9784 16.7214C14.5467 16.5488 15.1729 16.5488 16.4252 16.5488H17.8C18.9201 16.5488 19.4802 16.5488 19.908 16.3308C20.2843 16.1391 20.5903 15.8331 20.782 15.4568C21 15.029 21 14.4689 21 13.3488V4.74883C21 3.62872 21 3.06867 20.782 2.64085C20.5903 2.26452 20.2843 1.95856 19.908 1.76682C19.4802 1.54883 18.9201 1.54883 17.8 1.54883H17.4C15.1598 1.54883 14.0397 1.54883 13.184 1.9848C12.4314 2.3683 11.8195 2.98022 11.436 3.73287C11 4.58851 11 5.70862 11 7.94883"
                          stroke="#7F56D9"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    VOCABULARY IN 7 DIFFERENT <br /> CATEGORIES
                  </h3>
                  <p>
                    A complete list of 2000+ words included and explained in
                    various native languages with translations.
                  </p>
                </div>
                <div className="feature-card card2">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="22"
                        height="23"
                        viewBox="0 0 22 23"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15 7.54883V4.54883L18 1.54883L19 3.54883L21 4.54883L18 7.54883H15ZM15 7.54883L11 11.5488M21 11.5488C21 17.0717 16.5228 21.5488 11 21.5488C5.47715 21.5488 1 17.0717 1 11.5488C1 6.02598 5.47715 1.54883 11 1.54883M16 11.5488C16 14.3103 13.7614 16.5488 11 16.5488C8.23858 16.5488 6 14.3103 6 11.5488C6 8.7874 8.23858 6.54883 11 6.54883"
                          stroke="#94C23C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    MOCK TESTS LIKE <br /> REAL-TIME EXAM
                  </h3>
                  <p>
                    Experience the actual test environment to understand what to
                    expect and how to perform optimally.
                  </p>
                </div>
                <div className="feature-card card3">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M6 8.04883H10M6 11.5488H13M10 19.5488C14.9706 19.5488 19 15.5194 19 10.5488C19 5.57827 14.9706 1.54883 10 1.54883C5.02944 1.54883 1 5.57827 1 10.5488C1 11.746 1.23374 12.8885 1.65806 13.9333C1.73927 14.1333 1.77988 14.2333 1.798 14.3141C1.81572 14.3932 1.8222 14.4517 1.82221 14.5327C1.82222 14.6155 1.80718 14.7057 1.77711 14.8862L1.18413 18.4441C1.12203 18.8166 1.09098 19.0029 1.14876 19.1376C1.19933 19.2555 1.29328 19.3495 1.41118 19.4001C1.54589 19.4578 1.73218 19.4268 2.10476 19.3647L5.66265 18.7717C5.84309 18.7416 5.9333 18.7266 6.01613 18.7266C6.09715 18.7266 6.15566 18.7331 6.23472 18.7508C6.31554 18.7689 6.41552 18.8096 6.61549 18.8908C7.6603 19.3151 8.80286 19.5488 10 19.5488Z"
                          stroke="#0286FF"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    COMPREHENSIVE <br /> PRACTICE DIALOGUES
                  </h3>
                  <p>
                    Dialogues from different categories and scenarios similar to
                    previous exams, with 80+ practice dialogues including sample
                    responses prepared by certified interpreters.
                  </p>
                </div>
                <div className="feature-card card4">
                  <div className="rounded-circle">
                    <div className="img-wrapper">
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12 6.54883V12.5488L16 14.5488M22 12.5488C22 18.0717 17.5228 22.5488 12 22.5488C6.47715 22.5488 2 18.0717 2 12.5488C2 7.02598 6.47715 2.54883 12 2.54883C17.5228 2.54883 22 7.02598 22 12.5488Z"
                          stroke="#FFB02C"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                  <h3>
                    LAST-MINUTE <br /> PREPARATION PACKAGE
                  </h3>
                  <p>
                    Short packages with expert tips to boost your confidence
                    before the exam.
                  </p>
                </div>
              </div>
              <div className="text-center">
                <a href="#downlaodApp" className="primary-btn">
                  DOWNLOAD OUR APP AND START PRACTICING
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="master-aspect-section">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center">
                MASTER EVERY ASPECT
                <br />
                OF THE{" "}
                <span className="wpl-badge pte-naati-badge text-white">
                  NAATI CCL EXAM
                </span>
              </h2>
              <p className="sub-heading text-center">
                To succeed in the NAATI CCL exam, you need
                <br className="d-none d-md-block" />
                to excel in both <strong>translation</strong> and{" "}
                <strong>interpretation.</strong>
              </p>
              <h4 className="sub-sub-title">Here's how we help you prepare</h4>

              <div className="master-cards">
                <div className="master-card">
                  <div className="img-wrapper">
                    <svg
                      width="24"
                      height="25"
                      viewBox="0 0 24 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M21 18.71V12.71C21 7.7394 16.9706 3.70996 12 3.70996C7.02944 3.70996 3 7.7394 3 12.71V18.71M5.5 21.71C4.11929 21.71 3 20.5907 3 19.21V17.21C3 15.8292 4.11929 14.71 5.5 14.71C6.88071 14.71 8 15.8292 8 17.21V19.21C8 20.5907 6.88071 21.71 5.5 21.71ZM18.5 21.71C17.1193 21.71 16 20.5907 16 19.21V17.21C16 15.8292 17.1193 14.71 18.5 14.71C19.8807 14.71 21 15.8292 21 17.21V19.21C21 20.5907 19.8807 21.71 18.5 21.71Z"
                        stroke="#7F56D9"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">LISTENING</h2>
                  <ul>
                    <li>
                      <h4>
                        <span className="circle"></span> What It Tests
                      </h4>
                      <p>Understanding accents, tones, and cultural nuances.</p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> Our Approach
                      </h4>
                      <p>
                        Audio-based exercises with a focus on improving
                        comprehension and cultural sensitivity.
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card2">
                  <div className="img-wrapper">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M13.249 17.71H20.4229M13.249 17.71L11.3359 21.71M13.249 17.71L16.1142 11.719C16.3451 11.2362 16.4606 10.9949 16.6185 10.9186C16.7559 10.8522 16.916 10.8522 17.0534 10.9186C17.2113 10.9949 17.3268 11.2362 17.5576 11.719L20.4229 17.71M20.4229 17.71L22.3359 21.71M2.33594 5.70996H8.33594M8.33594 5.70996H11.8359M8.33594 5.70996V3.70996M11.8359 5.70996H14.3359M11.8359 5.70996C11.3398 8.66725 10.1885 11.3461 8.50149 13.5944M10.3359 14.71C9.72341 14.4348 9.09859 14.052 8.50149 13.5944M8.50149 13.5944C7.14896 12.5577 5.9387 11.1366 5.33594 9.70996M8.50149 13.5944C6.8968 15.7329 4.80737 17.4818 2.33594 18.71"
                        stroke="#94C23C"
                        strokeOpacity="0.98"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">
                    TRANSLATION & <br /> INTERPRETATION
                  </h2>
                  <ul>
                    <li>
                      <h4>
                        <span className="circle"></span> What It Tests
                      </h4>
                      <p>Fluency, accuracy, and logical delivery in both English and your chosen language</p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> Our Approach
                      </h4>
                      <p>
                        Practice real-life dialogues, vocabulary building, and targeted mock tests.
                      </p>
                    </li>
                  </ul>
                </div>
                <div className="master-card card3">
                  <div className="img-wrapper">
                    <svg
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.6641 6.70996V12.71L16.6641 14.71M22.6641 12.71C22.6641 18.2328 18.1869 22.71 12.6641 22.71C7.14121 22.71 2.66406 18.2328 2.66406 12.71C2.66406 7.18711 7.14121 2.70996 12.6641 2.70996C18.1869 2.70996 22.6641 7.18711 22.6641 12.71Z"
                        stroke="#0286FF"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </div>
                  <h2 className="card-title">TIME MANAGEMENT</h2>
                  <ul>
                    <li>
                      <h4>
                        <span className="circle"></span> What It Tests
                      </h4>
                      <p>Staying calm and composed under pressure to meet time constraints.</p>
                    </li>
                    <li>
                      <h4>
                        <span className="circle"></span> Our Approach
                      </h4>
                      <p>
                        Strategies to handle time efficiently during the test without compromising accuracy.
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="text-center bottom-btn-wrapper">
                <p className="sub-heading">
                  Gain confidence in every skill area and deliver your best performance on exam day.
                </p>
                {/* <Link to="/auth/register" className="primary-btn">
                  SIGN UP FOR OUR PREP PROGRAM NOW{" "}
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link> */}
                <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn">
                  SIGN UP FOR OUR PREP PROGRAM NOW{" "}
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="noc-why-choose why-most-section">
          <div className="container">
            <div className="row why-most-second-row">
              <div className="col-lg-6 why-most-content">
                <h2 className="primary-heading fw-700">
                  WHY CHOOSE <br /> LANGUAGE ACADEMY
                  <br />
                  <span className="wpl-badge text-white">NAATI CCL EXAM</span>
                  <br />
                  PREPARATION
                </h2>
                <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register">
                  <span className="btn-inner">
                    EXPERIENCE OUR COMPREHENSIVE APPROACH{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </a>
                {/* <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    EXPERIENCE OUR COMPREHENSIVE APPROACH{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link> */}
              </div>
              <div className="col-lg-6">
                <div className="why-most-list">
                  <ul>
                    <li className="list1">
                      <span className="list-counting">
                        {/* <img src="/images/web-new-images/icons/pc-01.svg" alt="Image" /> */}
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M19.9847 6.99798L22.4736 9.48687L27.4514 4.50909M27.4514 15.7091V22.1802C27.4514 24.2711 27.4514 25.3165 27.0445 26.1151C26.6866 26.8176 26.1154 27.3887 25.413 27.7466C24.6144 28.1535 23.5689 28.1535 21.4781 28.1535H8.53583C6.44497 28.1535 5.39954 28.1535 4.60094 27.7466C3.89846 27.3887 3.32734 26.8176 2.96941 26.1151C2.5625 25.3165 2.5625 24.2711 2.5625 22.1802V9.23798C2.5625 7.14712 2.5625 6.10169 2.96941 5.30308C3.32734 4.60061 3.89846 4.02948 4.60094 3.67156C5.39954 3.26465 6.44497 3.26465 8.53583 3.26465H15.0069M2.74358 25.573C3.3274 23.4727 5.25369 21.9313 7.53999 21.9313H16.2511C17.4076 21.9313 17.9858 21.9313 18.4667 22.027C20.4413 22.4197 21.9849 23.9633 22.3777 25.938C22.4733 26.4188 22.4733 26.9971 22.4733 28.1535M17.4958 12.598C17.4958 15.3471 15.2672 17.5758 12.5181 17.5758C9.76891 17.5758 7.54028 15.3471 7.54028 12.598C7.54028 9.84883 9.76891 7.6202 12.5181 7.6202C15.2672 7.6202 17.4958 9.84883 17.4958 12.598Z"
                            stroke="#7F56D9"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>EXPERIENCED TRAINERS</h3>
                        <p>
                          Our experienced trainers help you improve your reading, writing, listening, and speaking sections for NAATI CCL online coaching preparation.
                        </p>
                      </div>
                    </li>
                    <li className="list2">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9.86398 20.0148L8.78299 28.1535L14.493 24.7275C14.6792 24.6158 14.7723 24.5599 14.8718 24.5381C14.9597 24.5188 15.0507 24.5188 15.1387 24.5381C15.2381 24.5599 15.3312 24.6158 15.5174 24.7275L21.2274 28.1535L20.1472 20.0113M20.513 6.06325C20.7052 6.52808 21.0741 6.89755 21.5386 7.09045L23.1674 7.76516C23.6323 7.95771 24.0016 8.32704 24.1941 8.7919C24.3867 9.25676 24.3867 9.77908 24.1941 10.2439L23.5199 11.8717C23.3273 12.3367 23.327 12.8596 23.5205 13.3244L24.1936 14.9517C24.289 15.1819 24.3382 15.4287 24.3382 15.6779C24.3383 15.9272 24.2892 16.174 24.1938 16.4043C24.0984 16.6345 23.9586 16.8437 23.7824 17.02C23.6061 17.1962 23.3968 17.3359 23.1665 17.4312L21.5389 18.1055C21.0741 18.2977 20.7046 18.6666 20.5117 19.1311L19.837 20.76C19.6445 21.2249 19.2752 21.5942 18.8103 21.7867C18.3455 21.9793 17.8232 21.9793 17.3583 21.7867L15.7307 21.1125C15.2658 20.9204 14.7437 20.9208 14.2791 21.1136L12.6503 21.7874C12.1857 21.9795 11.6639 21.9793 11.1994 21.7869C10.735 21.5945 10.3658 21.2256 10.1732 20.7613L9.49828 19.1319C9.30609 18.667 8.93718 18.2976 8.47267 18.1047L6.84383 17.43C6.37919 17.2375 6.00998 16.8684 5.81737 16.4038C5.62475 15.9392 5.62449 15.4171 5.81664 14.9524L6.49084 13.3246C6.68291 12.8598 6.68252 12.3376 6.48975 11.873L5.81652 10.243C5.72106 10.0127 5.67191 9.76595 5.67188 9.51671C5.67184 9.26746 5.72091 9.02066 5.81628 8.79039C5.91166 8.56012 6.05148 8.3509 6.22774 8.17468C6.404 7.99847 6.61326 7.85872 6.84355 7.76341L8.47122 7.08918C8.93562 6.89715 9.30486 6.5287 9.49789 6.0647L10.1726 4.4358C10.3651 3.97094 10.7344 3.60161 11.1993 3.40906C11.6641 3.21651 12.1864 3.21651 12.6513 3.40906L14.2789 4.08329C14.7438 4.27537 15.2659 4.27497 15.7305 4.0822L17.36 3.41011C17.8248 3.21766 18.3469 3.2177 18.8117 3.41022C19.2765 3.60273 19.6457 3.97195 19.8383 4.43669L20.5132 6.06608L20.513 6.06325Z"
                            stroke="#0286FF"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>HIGHEST SUCCESS RATE</h3>
                        <p>
                          We continuously involve ourselves personally with every NAATI CCL coaching student, enabling them to unleash their potential and achieve the highest scores possible.
                        </p>
                      </div>
                    </li>
                    <li className="list3">
                      <span className="list-counting">
                        <svg
                          width="28"
                          height="25"
                          viewBox="0 0 28 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0069 23.9088L13.8824 23.722C13.018 22.4254 12.5858 21.777 12.0147 21.3077C11.5092 20.8922 10.9267 20.5804 10.3005 20.3903C9.59321 20.1755 8.81401 20.1755 7.25561 20.1755H5.54472C4.15081 20.1755 3.45386 20.1755 2.92146 19.9042C2.45314 19.6656 2.07239 19.2848 1.83377 18.8165C1.5625 18.2841 1.5625 17.5871 1.5625 16.1932V5.49101C1.5625 4.0971 1.5625 3.40015 1.83377 2.86775C2.07239 2.39943 2.45314 2.01868 2.92146 1.78006C3.45386 1.50879 4.15081 1.50879 5.54472 1.50879H6.0425C8.83032 1.50879 10.2242 1.50879 11.289 2.05133C12.2257 2.52857 12.9872 3.29007 13.4644 4.2267C14.0069 5.29151 14.0069 6.68542 14.0069 9.47323M14.0069 23.9088V9.47323M14.0069 23.9088L14.1315 23.722C14.9959 22.4254 15.4281 21.777 15.9992 21.3077C16.5047 20.8922 17.0872 20.5804 17.7134 20.3903C18.4207 20.1755 19.1999 20.1755 20.7583 20.1755H22.4692C23.8631 20.1755 24.56 20.1755 25.0924 19.9042C25.5608 19.6656 25.9415 19.2848 26.1801 18.8165C26.4514 18.2841 26.4514 17.5871 26.4514 16.1932V5.49101C26.4514 4.0971 26.4514 3.40015 26.1801 2.86775C25.9415 2.39943 25.5608 2.01868 25.0924 1.78006C24.56 1.50879 23.8631 1.50879 22.4692 1.50879H21.9714C19.1836 1.50879 17.7897 1.50879 16.7249 2.05133C15.7882 2.52857 15.0267 3.29007 14.5495 4.2267C14.0069 5.29151 14.0069 6.68542 14.0069 9.47323"
                            stroke="#94C23C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>FREE STUDY MATERIALS</h3>
                        <p>
                          Every NAATI online course student gets proven templates and free books to study and understand the best approach to excel in the exam.
                        </p>
                      </div>
                    </li>
                    <li className="list4">
                      <span className="list-counting">
                        <svg
                          width="20"
                          height="25"
                          viewBox="0 0 20 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M10.0002 13.9532V6.48657M6.26684 10.2199H13.7335M18.7113 23.9088V7.48212C18.7113 5.39126 18.7113 4.34583 18.3044 3.54722C17.9465 2.84475 17.3753 2.27363 16.6729 1.9157C15.8742 1.50879 14.8288 1.50879 12.738 1.50879H7.2624C5.17153 1.50879 4.1261 1.50879 3.3275 1.9157C2.62503 2.27363 2.0539 2.84475 1.69597 3.54722C1.28906 4.34583 1.28906 5.39126 1.28906 7.48212V23.9088L10.0002 18.931L18.7113 23.9088Z"
                            stroke="#FFB02C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>LATEST RESOURCES</h3>
                        <p>
                         Students can easily access study materials and take practice tests through our NAATI CCL Online Classes mobile app with just a few taps.
                        </p>
                      </div>
                    </li>
                    <li className="list5">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M3.41712 20.2452L5.79177 18.8744C5.92039 18.8001 6.07133 18.7743 6.21731 18.8017L10.8896 19.6761C11.2736 19.748 11.628 19.4524 11.6263 19.0617L11.6081 14.968C11.6076 14.8567 11.6369 14.7474 11.693 14.6514L14.0509 10.6146C14.1736 10.4045 14.1626 10.1422 14.0227 9.94309L10.0527 4.29217M23.7183 6.82258C16.8739 10.1091 20.607 14.4647 21.8517 15.0869C24.1876 16.2547 27.436 16.3313 27.436 16.3313C27.4462 16.1252 27.4514 15.9177 27.4514 15.7091C27.4514 8.83622 21.8798 3.26465 15.0069 3.26465C8.13407 3.26465 2.5625 8.83622 2.5625 15.7091C2.5625 22.582 8.13407 28.1535 15.0069 28.1535C15.2156 28.1535 15.423 28.1484 15.6292 28.1383M20.9277 28.0786L16.9869 17.689L27.3765 21.6299L22.7693 23.4715L20.9277 28.0786Z"
                            stroke="#48A75C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>ONLINE SUPPORT</h3>
                        <p>
                          During the entire course duration, our experts are available to answer all your questions and help wherever you're stuck.
                        </p>
                      </div>
                    </li>
                    <li className="list6">
                      <span className="list-counting">
                        <svg
                          width="22"
                          height="28"
                          viewBox="0 0 22 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.4913 1.59998V6.74021C13.4913 7.43716 13.4913 7.78564 13.627 8.05184C13.7463 8.286 13.9366 8.47637 14.1708 8.59568C14.437 8.73132 14.7855 8.73132 15.4824 8.73132H20.6227M20.958 11.2056V20.1802C20.958 22.2711 20.958 23.3165 20.5511 24.1151C20.1932 24.8176 19.622 25.3887 18.9196 25.7466C18.1209 26.1535 17.0755 26.1535 14.9847 26.1535H7.02021C4.92935 26.1535 3.88391 26.1535 3.08531 25.7466C2.38284 25.3887 1.81171 24.8176 1.45378 24.1151C1.04688 23.3165 1.04688 22.2711 1.04688 20.1802V7.23798C1.04688 5.14712 1.04688 4.10169 1.45378 3.30308C1.81171 2.60061 2.38284 2.02948 3.08531 1.67156C3.88391 1.26465 4.92935 1.26465 7.02021 1.26465H11.0171C11.9302 1.26465 12.3868 1.26465 12.8165 1.3678C13.1974 1.45926 13.5616 1.6101 13.8956 1.81479C14.2723 2.04567 14.5952 2.36851 15.2409 3.0142L19.2084 6.98177C19.8541 7.62745 20.177 7.9503 20.4078 8.32705C20.6125 8.66108 20.7634 9.02525 20.8548 9.40618C20.958 9.83584 20.958 10.2924 20.958 11.2056Z"
                            stroke="#0286FF"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>3500+ QUESTIONS TO PRACTICE</h3>
                        <p>
                          We have curated several previous question papers to help students practice common questions asked frequently.
                        </p>
                      </div>
                    </li>
                    <li className="list7">
                      <span className="list-counting">
                        <svg
                          width="28"
                          height="28"
                          viewBox="0 0 28 28"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M11.5181 17.4424L7.69107 21.3173C7.15726 21.8577 6.89035 22.128 6.66093 22.147C6.46189 22.1636 6.26702 22.0836 6.13703 21.9319C5.98719 21.7572 5.98719 21.3773 5.98719 20.6177V18.6764C5.98719 17.9949 5.42908 17.5018 4.75475 17.403V17.403C3.12271 17.164 1.84098 15.8822 1.60192 14.2502C1.5625 13.9811 1.5625 13.66 1.5625 13.0177V7.23798C1.5625 5.14712 1.5625 4.10169 1.96941 3.30308C2.32734 2.60061 2.89846 2.02948 3.60094 1.67156C4.39954 1.26465 5.44497 1.26465 7.53583 1.26465H16.7447C18.8356 1.26465 19.881 1.26465 20.6796 1.67156C21.3821 2.02948 21.9532 2.60061 22.3111 3.30308C22.7181 4.10169 22.7181 5.14712 22.7181 7.23798V12.4646M22.7181 26.1535L20.0096 24.2705C19.6289 24.0059 19.4386 23.8735 19.2314 23.7797C19.0475 23.6964 18.8542 23.6358 18.6557 23.5992C18.432 23.558 18.2001 23.558 17.7364 23.558H15.5003C14.1064 23.558 13.4094 23.558 12.877 23.2867C12.4087 23.0481 12.0279 22.6673 11.7893 22.199C11.5181 21.6666 11.5181 20.9697 11.5181 19.5758V16.4469C11.5181 15.053 11.5181 14.356 11.7893 13.8236C12.0279 13.3553 12.4087 12.9745 12.877 12.7359C13.4094 12.4647 14.1064 12.4646 15.5003 12.4646H22.4692C23.8631 12.4646 24.56 12.4647 25.0924 12.7359C25.5608 12.9745 25.9415 13.3553 26.1801 13.8236C26.4514 14.356 26.4514 15.053 26.4514 16.4469V19.8247C26.4514 20.9843 26.4514 21.5642 26.2619 22.0216C26.0093 22.6314 25.5248 23.1159 24.915 23.3685C24.4576 23.558 23.8777 23.558 22.7181 23.558V26.1535Z"
                            stroke="#FFB02C"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>DISCUSSION SESSIONS</h3>
                        <p>
                          Our experts note student weaknesses and strengths during discussion sessions to devise personalized study plans.
                        </p>
                      </div>
                    </li>
                    <li className="list8">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M7.54028 14.464V19.4418M22.4736 11.9752V16.9529M21.2292 5.75293C24.2764 5.75293 25.9246 6.2193 26.7447 6.58104C26.8539 6.62921 26.9085 6.6533 27.0661 6.8037C27.1606 6.89386 27.333 7.1584 27.3774 7.28122C27.4514 7.48612 27.4514 7.59812 27.4514 7.82212V21.1979C27.4514 22.3288 27.4514 22.8943 27.2818 23.1849C27.1093 23.4806 26.9429 23.618 26.62 23.7317C26.3026 23.8434 25.6618 23.7202 24.3803 23.474C23.4833 23.3017 22.4195 23.1752 21.2292 23.1752C17.4958 23.1752 13.7625 25.664 8.78472 25.664C5.73744 25.664 4.08927 25.1977 3.2692 24.8359C3.15999 24.7878 3.10538 24.7637 2.94778 24.6133C2.85331 24.5231 2.68087 24.2586 2.63651 24.1358C2.5625 23.9309 2.5625 23.8189 2.5625 23.5948L2.5625 10.2191C2.5625 9.08815 2.5625 8.52269 2.73209 8.23204C2.9046 7.93639 3.07097 7.79894 3.39386 7.68532C3.71129 7.57362 4.35205 7.69673 5.63358 7.94296C6.53056 8.11531 7.59439 8.24182 8.78472 8.24182C12.5181 8.24182 16.2514 5.75293 21.2292 5.75293ZM18.1181 15.7085C18.1181 17.4267 16.7252 18.8196 15.0069 18.8196C13.2887 18.8196 11.8958 17.4267 11.8958 15.7085C11.8958 13.9903 13.2887 12.5974 15.0069 12.5974C16.7252 12.5974 18.1181 13.9903 18.1181 15.7085Z"
                            stroke="#7F56D9"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>AFFORDABLE NAATI COURSE FEE</h3>
                        <p>
                          Our costs are pocket-friendly so students can easily pay their NAATI course fee and improve their scores through our NAATI CCL training centre programs.
                        </p>
                      </div>
                    </li>
                    <li className="list9">
                      <span className="list-counting">
                        <svg
                          width="30"
                          height="31"
                          viewBox="0 0 30 31"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M15.0069 8.24243V15.7091L19.9847 18.198M27.4514 15.7091C27.4514 22.582 21.8798 28.1535 15.0069 28.1535C8.13407 28.1535 2.5625 22.582 2.5625 15.7091C2.5625 8.83622 8.13407 3.26465 15.0069 3.26465C21.8798 3.26465 27.4514 8.83622 27.4514 15.7091Z"
                            stroke="#0286FF"
                            strokeWidth="1.86667"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                      <div>
                        <h3>REAL-TIME TEST ENVIRONMENT</h3>
                        <p>
                          Our mock tests provide students with the actual experience of taking tests, allowing them to test their interpretation skills effectively.
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="prepare-section">
          <div className="container">
            <div className="row">
              <div className="col-md-12">
                <div className="prepare-header position-relative">
                  <h2 className="primary-heading text-center">
                    How to Prepare
                  </h2>
                  <p className="sub-heading text-center">
                    Language Academy provides you the best practice materials
                    that can help <br className="d-none d-lg-block" /> you
                    achieve 5 bonus points required for Australian PR
                  </p>
                </div>
                <div className="prepare-cards">
                  <div className="prepare-card prepare-card1">
                    <div className="img-wrapper card-1">
                      <img
                        src="/images/web-new-images/expert-trainers.png"
                        alt="LA"
                      />
                    </div>
                    <h2 className="card-title">NAATI CCL Practice Material</h2>
                    <p className="card-description">
                      Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu,
                      Malayalam, Gujarati and Sinhalese
                    </p>
                  </div>
                  <div className="prepare-card prepare-card2">
                    <div className="img-wrapper card-2">
                      <img
                        src="/images/web-new-images/success-rate.png"
                        alt="LA"
                      />
                    </div>
                    <h2 className="card-title">NAATI CCL Vocabulary</h2>
                    <p className="card-description">
                      Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu,
                      Malayalam, Gujarati and Sinhalese
                    </p>
                  </div>
                  <div className="prepare-card prepare-card3">
                    <div className="img-wrapper card-3">
                      <img
                        src="/images/web-new-images/online-support.png"
                        alt="LA"
                      />
                    </div>
                    <h2 className="card-title">NAATI CCL Test Practice</h2>
                    <p className="card-description">
                      Dialogues Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil,
                      Telugu, Malayalam, Gujarati and Sinhalese
                    </p>
                  </div>
                </div>
                <div className="text-center">
                  <Link to="/auth/register" className="primary-btn">
                    REGISTER NOW{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div className="feature-section poc-feature-section noc-feature p-0">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center mb-md-0 fw-700">
                HOW OUR NAATI <br /> <span className="wpl-badge pte-naati-badge text-white">
                  CCL ONLINE COACHING
                </span>
                <br /> PREPARATION WORKS
              </h2>
              <div className="position-relative">
                <div className="feature-cards card-45">
                  <div className="feature-card mint-green-card">
                    <div className="feature-icon-outer">
                      <div className="feature-count">
                        <span>1</span>
                      </div>
                    </div>
                    <h3>ORIENTATION CLASS</h3>
                    <p>
                      Learn the basics of NAATI CCL through our NAATI CCL training. Our experts guide you on how to gain maximum scores in the test.
                    </p>
                  </div>
                  <div className="feature-card blue-card">
                    <div className="feature-icon-outer">
                      <div className="feature-count">
                        <span>2</span>
                      </div>
                    </div>
                    <h3>LIVE PRACTICE SESSIONS</h3>
                    <p>
                      Our NAATI CCL coaching trainers monitor your performance and provide feedback on your dialogues and vocabulary usage.
                    </p>
                  </div>
                  <div className="feature-card greenish-yellow-card">
                    <div className="feature-icon-outer">
                      <div className="feature-count">
                        <span>3</span>
                      </div>
                    </div>
                    <h3>CCL PRACTICE APP ACCESS</h3>
                    <p>
                      Get access to our CCL app for excellent listening practice through our NAATI online course with audio recordings and sample answers.
                    </p>
                  </div>
                  <div className="feature-card purple-card">
                    <div className="feature-icon-outer">
                      <div className="feature-count">
                        <span>4</span>
                      </div>
                    </div>
                    <h3>WEEKLY MOCK TESTS</h3>
                    <p>
                      Take weekly tests through our NAATI CCL Online Classes and receive full scorecards with your scores and areas of improvement.
                    </p>
                  </div>
                  <div className="feature-card light-apricot-card">
                    <div className="feature-icon-outer">
                      <div className="feature-count">
                        <span>5</span>
                      </div>
                    </div>
                    <h3>FINAL CONSULTATION</h3>
                    <p>
                      Once you complete our NAATI CCL online course, our experts advise how much more practice you need before booking your exam.
                    </p>
                  </div>
                </div>
              </div>
              <div className="text-center">
                <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn dark-border">
                  START YOUR STEP-BY-STEP JOURNEY
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </a>
                {/* <Link to="/auth/register" className="primary-btn dark-border">
                  START YOUR STEP-BY-STEP JOURNEY
                  <img
                    src="/images/web-new-images/right-arrow.svg"
                    alt="Register Now"
                  />
                </Link> */}
              </div>
            </div>
          </div>
        </div>

        <div className="all-language-section">
          <div className="container">
            <div className="row">
              <h2 className="primary-heading text-center mb-md-0 fw-700">
                comprehensive{" "}
                <span className="wpl-badge gold-badge text-white">
                  PRACTICE MATERIALS
                </span>
                <br /> FOR ALL LANGUAGES
              </h2>
              <p className="sub-heading text-center mt-2">
                Language Academy provides the best practice materials <br /> to
                help you achieve the 5 bonus points required for Australian PR
              </p>
              <h4 className="sub-sub-title"> Here's how we help you prepare</h4>
            </div>

            <div className="all-language-content">
              <div className="all-lang-card">
                <h2 className="title">
                  NAATI CCL PRACTICE MATERIALS AVAILABLE IN
                </h2>
                <ul>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-01.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Hindi</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-02.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Tamil</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-03.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Marathi</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-04.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Telugu</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-05.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Punjabi</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-06.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Urdu</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-07.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Nepali</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-08.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Malayalam</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-09.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Sinhalese</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-10.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Bangla</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-11.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Gujarati</h3>
                  </li>
                  <li>
                    <div className="icon-wrapper">
                      <img
                        src="/images/web-new-images/icons/pm-12.png"
                        alt="Image"
                      />
                    </div>
                    <h3>Kannada</h3>
                  </li>
                </ul>
              </div>

              <div className="all-lang-card">
                <h2 className="title">NAATI CCL VOCABULARY BUILDING</h2>
                <p>
                  Comprehensive vocabulary lists in all 12 supported languages
                </p>
              </div>

              <div className="all-lang-card">
                <h2 className="title">NAATI CCL TEST PRACTICE DIALOGUES</h2>
                <p>Extensive dialogue practice in</p>
                <h4 className="sub-title">
                  Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Marathi and Kannada
                </h4>
              </div>
            </div>

            <div className="text-center">
              <Link to="/contact" className="primary-btn dark-border">
                ACCESS MATERIALS IN YOUR LANGUAGE
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="sss-section">
          <SuccessfulStudent title={`<span className="fw-700">HEAR FROM OUR</span> <br className="d-block" /><span className="wpl-badge pte-naati-badge text-white">successful students</span>`} />
          <div className="container">
            <div className="text-center bottom-btn-wrapper">
              <p className="sub-heading">
                Your success is our priority. Let us help you achieve your
                dreams!
              </p>
              <Link to="/contact" className="primary-btn">
                JOIN OUR SUCCESS STORIES
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
          </div>
        </div>
        <div className="pc-journey-section noc-journey-section">
          <div className="container">
            <div className="pc-journey-heading">
              <h2 className="primary-heading text-center text-white">
                CHOOSE YOUR NAATI CCL <br />{" "}
                <span className="wpl-badge text-white">ONLINE COACHING PLAN</span>
              </h2>
              <div className="sub-title text-white text-center">
                Choose between our affordable NAATI course fee options
              </div>
            </div>
            <div className="journey-cards-content">
              <h2 className="journey-card-title">ONLINE PLATFORM</h2>
              <div className="journey-cards d-none d-md-grid">
                <div className="journey-card card1">
                  <h2 className="feature-title">Feature</h2>
                  <ul>
                    <li>Real Exam Practice Material</li>
                    <li>Full Vocabulary Access</li>
                    <li>Full Length Mock Tests</li>
                    <li>Last Minute Practice</li>
                    <li>
                     1 Mock test with Scorecard and Feedback on Improvement
                    </li>
                  </ul>
                  <h2 className="price-title">Enroll</h2>
                </div>
                <div className="journey-card">
                  <h2 className="feature-title">Beginner - $119 (2 Months)</h2>
                  <ul>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="12"
                        height="13"
                        viewBox="0 0 12 13"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M11 1.71753L1 11.7175M1 1.71753L11 11.7175"
                          stroke="#E05263"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                  </ul>
                  <h2 className="price-title">
                    <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        ENROL NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </a>
                    {/* <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        ENROL NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link> */}
                  </h2>
                </div>
                <div className="journey-card">
                  <h2 className="feature-title">Pro - $189 (2 Months)</h2>
                  <ul>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                    <li>
                      <svg
                        width="18"
                        height="14"
                        viewBox="0 0 18 14"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M17 1.71753L6 12.7175L1 7.71753"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </li>
                  </ul>
                  <h2 className="price-title">
                    <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register" className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        ENROL NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </a>
                    {/* <Link className="primary-btn" to="/auth/register">
                      <span className="btn-inner">
                        ENROL NOW{" "}
                        <img
                          src="/images/web-new-images/right-arrow.svg"
                          alt="Register Now"
                        />
                      </span>
                    </Link> */}
                  </h2>
                </div>
              </div>

              {/* Mobile Code */}
              <div className="d-flex d-md-none pc-pte-mobile-card">
                <div className="pc-mobile-card">
                  <div className="pc-mobile-card-header">
                    <h2 className="title">Feature</h2>
                    <h2 className="sub-title">Beginner - $119 (2 Months)</h2>
                  </div>
                  <div className="pc-mobile-card-content">
                    <ul>
                      <li>
                        <span className="left-col">
                          Real Exam Practice Material
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">Full Vocabulary Access</span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">Full Length Mock Tests</span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">
                          Last Minute <br /> Practice
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">
                          1 Mock test <br /> with Scorecard <br /> and Feedback{" "}
                          <br /> on Improvement
                        </span>
                        <span className="right-col">
                          <svg
                            width="12"
                            height="13"
                            viewBox="0 0 12 13"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M11 1.41797L1 11.418M1 1.41797L11 11.418"
                              stroke="#E05263"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col price">Enroll</span>
                        <span className="right-col price">
                          <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register">
                            <span className="btn-inner">
                              ENROL NOW{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="Register Now"
                              />
                            </span>
                          </a>
                          {/* <Link className="primary-btn" to="/auth/register">
                            <span className="btn-inner">
                              ENROL NOW{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="Register Now"
                              />
                            </span>
                          </Link> */}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="pc-mobile-card">
                  <div className="pc-mobile-card-header">
                    <h2 className="title">Feature</h2>
                    <h2 className="sub-title">Pro - $189 (2 Months)</h2>
                  </div>
                  <div className="pc-mobile-card-content">
                    <ul>
                      <li>
                        <span className="left-col">
                          Real Exam <br /> Practice Material
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">
                          Full Vocabulary <br /> Access
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">
                          Full Length Mock <br /> Tests
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">
                          Last Minute <br /> Practice
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col">
                          1 Mock test <br /> with Scorecard <br /> and Feedback{" "}
                          <br /> on Improvement
                        </span>
                        <span className="right-col">
                          <svg
                            width="18"
                            height="14"
                            viewBox="0 0 18 14"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M17 1.71753L6 12.7175L1 7.71753"
                              stroke="#94C23C"
                              strokeWidth="1.8"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </span>
                      </li>
                      <li>
                        <span className="left-col price">Enroll</span>
                        <span className="right-col price">
                          <a target="_blank" href="https://www.laccl.languageacademy.com.au/auth/register">
                            <span className="btn-inner">
                              ENROL NOW{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="Register Now"
                              />
                            </span>
                          </a>
                          {/* <Link className="primary-btn" to="/auth/register">
                            <span className="btn-inner">
                              ENROL NOW{" "}
                              <img
                                src="/images/web-new-images/right-arrow.svg"
                                alt="Register Now"
                              />
                            </span>
                          </Link> */}
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row pc-journey-content">
              <div className="col-md-6">
                <p className="sub-title text-white">
                  The NAATI test ensures you have the necessary communication
                  skills to integrate successfully into Canadian society and
                  workplace environments.
                </p>
              </div>
              <div className="col-md-6 text-center text-md-right">
                <Link className="primary-btn" to="/auth/register">
                  <span className="btn-inner">
                    Register Now{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </span>
                </Link>
              </div>
            </div> */}
            <br />
            <br />
            <div className="text-center">
              <h2 className="online-coaching-heading">
                ONLINE COACHING{" "}
                {/* <span className="price-btn">
                  {" "}
                  <span className="btn-text">
                    Starting <br /> Price
                  </span>{" "}
                  <span className="btn-price">$349</span>
                </span> */}
              </h2>
            </div>

            <div className="feature-cards online-coaching-cards card-56 d-none d-md-grid">
              <div className="feature-card card1">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#48A75C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>LIVE VIRTUAL CLASSES</h3>
                <p>
                  Join expert-led sessions focusing on each component of the
                  exam
                </p>
              </div>
              <div className="feature-card card2">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#0286FF"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>PERSONALIZED FEEDBACK</h3>
                <p>
                  Receive detailed analysis of your performance with specific
                  improvement strategies
                </p>
              </div>
              <div className="feature-card card3">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#94C23C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>DIRECT TRAINER ACCESS</h3>
                <p>
                  Get your questions answered directly by our experienced
                  instructors
                </p>
              </div>
              <div className="feature-card card4">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#FFB02C"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>PREDICTION FILES</h3>
                <p>
                  Access constantly updated prediction materials based on recent
                  exam patterns
                </p>
              </div>
              <div className="feature-card card5">
                <div className="feature-icon-outer">
                  <div className="feature-count">
                    <span>
                      <svg
                        width="24"
                        height="25"
                        viewBox="0 0 24 25"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M20 6.57812L9 17.5781L4 12.5781"
                          stroke="#7F56D9"
                          strokeWidth="1.8"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </div>
                </div>
                <h3>PRIORITY SUPPORT</h3>
                <p>
                  Fast-track assistance whenever you face challenges in your
                  preparation
                </p>
              </div>
            </div>

            {/* Mobile Slider HTML */}
            <div className="slider-dot-arrow d-block d-md-none">
              <Slider
                {...CardsSlider}
                className="feature-cards online-coaching-cards card-56"
              >
                <div className="feature-card card1">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#48A75C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>LIVE VIRTUAL CLASSES</h3>
                  <p>
                    Join expert-led sessions focusing on each component of the
                    exam
                  </p>
                </div>
                <div className="feature-card card2">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#0286FF"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>PERSONALIZED FEEDBACK</h3>
                  <p>
                    Receive detailed analysis of your performance with specific
                    improvement strategies
                  </p>
                </div>
                <div className="feature-card card3">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#94C23C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>DIRECT TRAINER ACCESS</h3>
                  <p>
                    Get your questions answered directly by our experienced
                    instructors
                  </p>
                </div>
                <div className="feature-card card4">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#FFB02C"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>PREDICTION FILES</h3>
                  <p>
                    Access constantly updated prediction materials based on
                    recent exam patterns
                  </p>
                </div>
                <div className="feature-card card5">
                  <div className="feature-icon-outer">
                    <div className="feature-count">
                      <span>
                        <svg
                          width="24"
                          height="25"
                          viewBox="0 0 24 25"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M20 6.57812L9 17.5781L4 12.5781"
                            stroke="#7F56D9"
                            strokeWidth="1.8"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </div>
                  </div>
                  <h3>PRIORITY SUPPORT</h3>
                  <p>
                    Fast-track assistance whenever you face challenges in your
                    preparation
                  </p>
                </div>
              </Slider>
            </div>

            <div className="text-center">
              <Link to="/contact" className="primary-btn">
                SELECT YOUR PLAN
                <img
                  src="/images/web-new-images/right-arrow.svg"
                  alt="Register Now"
                />
              </Link>
            </div>
            <div className="downlaodnow-row" id="downlaodApp">
              <div className="downlaodnow-content">
                <h2>NAATI CCL</h2>
                <p>
                  Download our NA CCL App
                  <br />
                  from App Store and Play Store
                </p>
              </div>
              <div className="downlaodnow-img">
                <img
                  src="/images/web-new-images/welcome-img-01.png"
                  alt="Register Now"
                />
              </div>
              <div className="downlaodnow-third-col">
                <h3 className="downlaodnow-title">Download Now!</h3>
                <div className="downlaodnow-btns">
                  <a target="_blank" href="https://play.google.com/store/apps/details?id=com.languageacademy.naati" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/google-play-01.svg"
                      alt="Register Now"
                    />
                  </a>
                  <a target="_blank" href="https://apps.apple.com/au/app/la-ccl/id1536541464" className="downlaod-btn">
                    <img
                      src="/images/web-new-images/app-store-01.svg"
                      alt="Register Now"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="faq-section mt-80">
          <div className="container">
            <div className="row">
              <h2 className="secondary-heading text-center">
                Frequently Asked Questions
              </h2>
              <div className="accordion" id="accordionExample">
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                      aria-expanded="true"
                      aria-controls="collapseOne"
                    >
                      How long does it take to prepare for the NAATI CCL exam with your NAATI CCL training?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse show"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Most students need 4-6 weeks of consistent NAATI CCL coaching preparation, but it may vary depending on your current proficiency and practice time.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                      aria-expanded="false"
                      aria-controls="collapseTwo"
                    >
                      What languages do you offer NAATI CCL online course preparation in?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingTwo"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      We offer NAATI online course preparation in 12 languages: Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Marathi and Kannada.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                      aria-expanded="false"
                      aria-controls="collapseThree"
                    >
                      Can I reschedule my NAATI CCL Online Classes sessions?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingThree"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, we offer flexible scheduling options for our NAATI CCL online coaching to fit your availability, making online learning even more convenient.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                      aria-expanded="false"
                      aria-controls="collapseFour"
                    >
                      How does the NAATI CCL mobile app help with NAATI CCL training centre preparation?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFour"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Our app includes 2000+ vocabulary words, 80+ practice dialogues, mock tests that simulate the real exam environment through our NAATI CCL coaching system.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFive">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFive"
                      aria-expanded="false"
                      aria-controls="collapseFive"
                    >
                      What score do I need to pass the NAATI CCL exam? 
                    </button>
                  </h2>
                  <div
                    id="collapseFive"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingFive"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      You need to score a minimum of 29 out of 45 in each dialogue to pass the NAATI CCL exam successfully.
                    </div>
                  </div>
                </div>

                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingSix">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseSix"
                      aria-expanded="false"
                      aria-controls="collapseSix"
                    >
                     Do you provide practice materials for previous exam questions? 
                    </button>
                  </h2>
                  <div
                    id="collapseSix"
                    className="accordion-collapse collapse"
                    aria-labelledby="headingSix"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      Yes, we have curated over 3500+ questions from previous exams to help you practice the most commonly asked questions.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />
        <div
          className="modal fade"
          id="staticBackdrop1"
          data-bs-backdrop="static"
          data-bs-keyboard="false"
          tabIndex="-1"
          aria-labelledby="staticBackdropLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog main-popup">
            <div className="modal-content">
              <div className="modal-header">
                <button
                  type="button"
                  className="close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                >
                  <span aria-hidden="true">
                    <img
                      className="img-fluid"
                      src="/images/web-new-images/icons/close-icon2.svg"
                      alt="LA"
                    />
                  </span>
                </button>
              </div>
              <div className="modal-body p-0">
                <div className="form-content-outer m-0">
                  <div className="form-content">
                    <div className="main-popup-img form-img">
                      <img
                        className="img-fluid"
                        src="/images/web-new-images/hero_img-02.png"
                        alt="LA"
                      />
                    </div>
                    <div className="main-popup-content form-content-right">
                      <h4 className="popup-title">Take a FREE Demo Class</h4>
                      <p className="popup-sub-title">
                        Submit Your Details Below
                      </p>
                      <div className="pte-popup-form-start">
                        <form onSubmit={this.submitForm}>
                          <div className="fieldOuter">
                            <label htmlFor="name">Name*</label>
                            <div className="form-input-outer">
                              <input
                                id="name"
                                className="form-input"
                                type="text"
                                name="name"
                                placeholder="Enter Name"
                                value={this.state.name}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Name",
                              this.state.name,
                              "required"
                            )}
                          </div>
                          {/* <div className="fieldOuter">
                          <input
                            type="text"
                            name="phone"
                            placeholder="Phone*"
                            value={this.state.phone}
                            onChange={(e) => { this.changeInput(e)} }
                          />
                          {this.validator.message('Phone', this.state.phone, 'required')}
                        </div> */}
                          <div className="fieldOuter">
                            <label htmlFor="PhoneNumber">Phone Number</label>
                            <PhoneInputField
                              id="PhoneNumber"
                              value={this.state.phone}
                              changeEvent={this.handlePhoneChange}
                              addClass="popup-class"
                            />
                            {this.validator.message(
                              "phone",
                              this.state.phone,
                              "required|phone"
                            )}
                            <span className="err phone-error"></span>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="email">Email*</label>
                            <div className="form-input-outer">
                              <input
                                id="email"
                                className="form-input"
                                type="text"
                                name="email"
                                placeholder="Enter Email"
                                value={this.state.email}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Email",
                              this.state.email,
                              "required"
                            )}
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="course">Center</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                id="course"
                                className="form-input"
                                name="course"
                                value={this.state.course}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              >
                                <option value="NAATI CCL Online">
                                  NAATI CCL Online
                                </option>
                                <option value="PTE On-Campus1">
                                  PTE On-Campus
                                </option>
                                <option value="NAATI CCL Online">
                                  PTE Online
                                </option>
                                <option value="NAATI CCL On-Campus">
                                  NAATI CCL On-Campus
                                </option>
                                <option value="IELTS Online">
                                  IELTS Online
                                </option>
                                <option value="IELTS On-Campus">
                                  IELTS On-Campus
                                </option>
                              </select>
                            </div>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="language">Language</label>
                            <div className="form-input-outer form-select-wrapper">
                              <select
                                id="lang"
                                className="form-input"
                                name="lang"
                                value={this.state.lang}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              >
                                <option value="Hindi">Hindi</option>
                                <option value="Punjabi">Punjabi</option>
                                <option value="Urdu">Urdu</option>
                                <option value="Nepali">Nepali</option>
                                <option value="Bangla">Bangla</option>
                                <option value="Tamil">Tamil</option>
                                <option value="Telugu">Telugu</option>
                                <option value="Sinhalese">Sinhalese</option>
                                <option value="Malayalam">Malayalam</option>
                                <option value="Gujarati">Gujarati</option>
                                <option value="Kannada">Kannada</option>
                              </select>
                            </div>
                          </div>
                          <div className="fieldOuter">
                            <label htmlFor="language">Comments / Query</label>
                            <div className="form-input-outer">
                              <input
                                className="form-input"
                                type="text"
                                name="query"
                                placeholder="Enter your comments/Query"
                                value={this.state.query}
                                onChange={(e) => {
                                  this.changeInput(e);
                                }}
                              />
                            </div>
                            {this.validator.message(
                              "Query",
                              this.state.query,
                              "required"
                            )}
                          </div>
                          <div className="fieldOuter mb-0">
                            {!this.state.loginLock && (
                              <button
                                className="primary-btn"
                                onClick={(e) => {
                                  this.hitApi();
                                }}
                              >
                                SUBMIT{" "}
                                <img
                                  src="/images/web-new-images/right-arrow.svg"
                                  alt="LA"
                                />
                              </button>
                            )}
                            {this.state.loginLock && (
                              <button className="themeBtn">Wait...</button>
                            )}
                          </div>
                        </form>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Pte;
